import axios from 'axios'
import { saveItem, getItem, removeAll } from './storage'
import { getUserInfo } from './auth'
import { warning } from './message'
import router from '../router'
import {isWeiXin} from '@/utils/tools'

// import { notifyWarning } from './message'
// import { getCommonHeaders } from 'src/api/server/common'

// 创建axios实例
const service = axios.create({
  // baseURL: 'http://192.168.3.119:22999',
  // baseURL: process.env.API_BASE,
  baseURL: '',
  timeout: 120000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  // let baseURL = getItem('baseURL') || process.env.API_BASE
  let baseURL = 'https://api.909.cn/api'
  // let baseURL = 'http://www.msmall.test/api'
  config.url = `${baseURL}/${config.url}`

  // Token
  let userinfo = getUserInfo()
  if (userinfo) {
    if (!config.params) {
      config.params = {}
    }
    config.params.token = userinfo.token
  }
  let locale = getItem('locale')
  if (locale) {
    config.params.local = locale
  }


  // Headers
  // let headers = getCommonHeaders()
  // notifyWarning('headers: ' + JSON.stringify(headers), 'top', 5000)
  // config.headers = Object.assign(config.headers, headers)

  // sign
  // if (config.url.indexOf('/user/identity') >= 0 || config.url.indexOf('/mining') >= 0) {
  //   let result = computeSign(config)
  //   config.headers = Object.assign(config.headers, result)
  //   // console.log('use sign', result, config.headers)
  // }

  return config
}, error => {
  // Do something with request error
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    let data = response.data
    if (data.status === 4030) {
      console.log('未登陆')
      // store.dispatch('CLEAN_USERINFO')
      // console.log('resignin')
      // router.push('/auth/signin')
    }

    return data
  },
  error => {
    let code = error.response.status
    if (code === 401) {
      removeAll()
      let url = router.history.current.fullPath
      saveItem('wx_backurl', '')
      warning('请登陆后操作')
      if (isWeiXin()) {
        console.log('request weixin')
        // 微信浏览器
         router.push('/wechat/oauth')
      } else {
        // 非微信浏览器
        router.push('/login')
      }
    }
    let message = error.message
    if (message.indexOf('Network Error') >= 0) {
      message = '' // Network Error, please retry
      // store.dispatch('A_AUTOCONFIG_APS')
    } else if (message.indexOf('timeout') >= 0) {
      message = '' // Timeout, please retry
      // store.dispatch('A_AUTOCONFIG_APS')
    }
    // if (message) notifyWarning(message, 'bottom')
    return Promise.reject(error)
  })

export default service
